module.exports = __webpack_public_path__ + "img/44be545.jpg";